(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/engine/assets/javascripts/actions.js') >= 0) return;  svs.modules.push('/components/tipsen/engine/assets/javascripts/actions.js'); "use strict";

var _svs$core$config$data, _svs$core$config$data2;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const {
  createAction,
  createAsyncThunk
} = RTK;
const {
  selectWager,
  selectWagers,
  selectWagerProps,
  selectCoupon,
  selectPrice,
  selectAllSigns,
  selectCouponBoardEmpty,
  selectIsRelatedCouponValid,
  selectCurrentAddonPixSizeIndex
} = svs.components.tipsen.engine.selectors.couponSelectors;
const {
  placeBetService,
  generateXpertCouponService,
  generateSportPixService
} = svs.components.tipsen.engine.services;
const {
  generateSportkryssNumber
} = svs.components.tipsen.engine.utils;
const {
  convertSignsTo1X2
} = svs.components.sport.tipsenShared.transformSigns;
const {
  XPERT_WAGER_RSYS,
  XPERT_WAGER_MSYS
} = svs.components.tipsen.engine.constants.xpertWagerSystemTypes;
const {
  SYSTEM_RSYS
} = svs.components.tipsen.engine.constants.systems;
const {
  selectRSystems,
  selectSystemTypes,
  selectExternalSystemChunkSize,
  selectAddonPixSizes
} = svs.components.tipsen.engine.selectors.engineSelectors;
const {
  selectEngineDefinition
} = svs.components.tipsen.engine.selectors;
const {
  userSession
} = svs.core;
const {
  WALLET_ID_PLAYER,
  WALLET_ID_SELFSERVICE
} = svs.components.tipsen.wallet.walletId;
const {
  selectById
} = svs.components.sport.drawsRedux.globalizedSelectors;
const {
  CurrencyFromJupiterString
} = svs.utils.format;
const {
  EventTypeId
} = svs.components.sportinfo.common.constants;
const {
  externalSystemsType,
  externalSystemsBoardsType
} = svs.components.tipsen.engine.constants;
const {
  getLogger
} = svs.core.log;
const {
  jupiter,
  detect
} = svs.core;
const {
  makeSelectRelatedDraw
} = svs.components.sport.drawsRedux.selectors;
const {
  LoadingKeys
} = svs.components.tipsen.loadingState.constants;
const {
  getTitleAndErrorMessageFromWagerResponse
} = svs.components.tipsen.engine.errorHelpers;
const hasRelatedDrawPix = detect.feature('ft-tipsen-addon-pix');
const switchEngine = createAction('tipsen/switchEngine');
const toggleAlternative = createAction('tipsen/toggleAlternative');
const setExternalCoupon = createAction('tipsen/setExternalCoupon');
const selectBetAmount = createAction('tipsen/selectBetAmount');
const setSportkryssFactorIndex = createAction('tipsen/setSportkryssFactorIndex');
const setSportkryssNumber = createAction('tipsen/setSportkryssNumber');
const clearCoupon = createAction('tipsen/clearCoupon');
const clearCouponBoard = createAction('tipsen/clearCouponBoard');
const selectWeek = createAction('tipsen/selectWeek');
const selectPixSize = createAction('tipsen/selectPixSize');
const selectSystem = createAction('tipsen/selectSystem');
const toggleMSign = createAction('tipsen/toggleMSign');
const setCouponValues = createAction('tipsen/setCouponValues');
const resetWithCouponValues = createAction('tipsen/resetWithCouponValues');
const setSignDistribution = createAction('tipsen/setSignDistribution');
const setReduceModeCount = createAction('tipsen/setReduceModeCount');
const {
  dialog
} = svs.components;
const isSelfService = (_svs$core$config$data = (_svs$core$config$data2 = svs.core.config.data.svsconfig) === null || _svs$core$config$data2 === void 0 ? void 0 : _svs$core$config$data2.isSelfService) !== null && _svs$core$config$data !== void 0 ? _svs$core$config$data : false;
const showErrorDialog = (message, title) => {
  const dialogOptions = {
    branding: svs.components.dialog.branding.SPORT,
    title: title ? title : 'Något gick fel!',
    icon: 'exclamation-sign',
    area: dialog.area.POPUP,
    type: dialog.type.ERROR,
    message: [{
      type: dialog.message.TEXT,
      text: message
    }],
    actions: [{
      title: 'OK',
      callback: () => {
        dialog.api.close();
      }
    }]
  };

  dialog.api.add(new svs.components.dialog.Confirm(dialogOptions));
};
const getTotalPaidSum = paidWagers => paidWagers.reduce((sum, wager) => {
  sum += CurrencyFromJupiterString(wager.wagerAmounts.totalAmount);
  return sum;
}, 0);
const _generateXpertCoupon = async (_ref, _ref2) => {
  let {
    productId,
    drawNumber,
    system,
    type,
    boards = [0],
    couponId,
    baseRow = [],
    keepUserSigns = false,
    xpertAnalysisAuthorId = null,
    overwriteCoupon = true
  } = _ref;
  let {
    getState
  } = _ref2;
  const rowAs1X2 = convertSignsTo1X2(baseRow);
  let rSystem;
  let xpertSystem = system;
  let couponSystem;
  const state = getState();
  if (type === XPERT_WAGER_RSYS) {
    rSystem = selectRSystems(state).indexOf(system);
    xpertSystem = state.Systems[system].rows.length;
    couponSystem = selectSystemTypes(state).indexOf(SYSTEM_RSYS);
  }
  try {
    const signs = await generateXpertCouponService({
      productId,
      drawNumber,
      systemSize: xpertSystem,
      systemType: type,
      numRows: boards.length,
      baseRow: rowAs1X2
    });
    const boardSigns = {};
    boards.forEach((board, index) => {
      boardSigns[board] = signs[index];
    });
    return {
      boardSigns,
      couponId,
      keepUserSigns,
      rSystem,
      system: couponSystem,
      xpertAnalysisAuthorId,
      overwriteCoupon
    };
  } catch (err) {
    showErrorDialog('Något gick fel, försök igen om en liten stund.');
    throw err;
  }
};
const generateXpertCoupon = createAsyncThunk('tipsen/generateXpertCoupon', async (_ref3, _ref4) => {
  let {
    data
  } = _ref3;
  let {
    getState
  } = _ref4;
  const {
    productId,
    drawNumber,
    system,
    type,
    numRows = 1,
    couponId,
    baseRow = [],
    keepUserSigns = false,
    xpertAnalysisAuthorId = null
  } = data;
  const boards = [];
  for (let i = 0; i < numRows; i++) {
    boards.push(i);
  }
  return _generateXpertCoupon({
    productId,
    drawNumber,
    system,
    type,
    boards,
    couponId,
    baseRow,
    keepUserSigns,
    xpertAnalysisAuthorId,
    overwriteCoupon: true
  }, {
    getState
  });
});
const generateXpertCouponBoard = createAsyncThunk('tipsen/generateXpertCoupon', async (_ref5, _ref6) => {
  let {
    data
  } = _ref5;
  let {
    getState
  } = _ref6;
  const {
    productId,
    drawNumber,
    system,
    type,
    boardIndex = 0,
    couponId,
    baseRow = [],
    keepUserSigns = false,
    xpertAnalysisAuthorId = null
  } = data;
  return _generateXpertCoupon({
    productId,
    drawNumber,
    system,
    type,
    boards: [boardIndex],
    couponId,
    baseRow,
    keepUserSigns,
    xpertAnalysisAuthorId,
    overwriteCoupon: false
  }, {
    getState
  });
});
const _generateSportPixCoupon = async _ref7 => {
  let {
    productId,
    drawNumber,
    system,
    boards = [0],
    couponId,
    baseRow: baseRows = [],
    keepUserSigns = false,
    xpertAnalysisAuthorId = null,
    overwriteCoupon = true
  } = _ref7;
  const guaranteedEvents = {
    events: []
  };
  if (baseRows) {
    const eventTypeId = EventTypeId.GOAL_COUNT;
    const signsToIndex = {
      [EventTypeId.EVENT_1X2]: ['1', 'X', '2'],
      [EventTypeId.GOAL_COUNT]: ['0', '1', '2', '3', '4', '5', '6', '7']
    };
    const signsForEventType = signsToIndex[eventTypeId];
    baseRows.forEach((baseRow, i) => {
      if (baseRow.find(sign => sign)) {
        const outcomes = [];
        baseRow.forEach((sign, signIndex) => {
          if (sign) {
            outcomes.push({
              value: signsForEventType[signIndex]
            });
          }
        });
        guaranteedEvents.events.push({
          eventNumber: i + 1,
          outcomes
        });
      }
    });
  }
  const signs = await generateSportPixService({
    productId,
    drawNumber,
    size: system,
    guaranteedEvents
  });
  const boardSigns = {};
  boards.forEach((board, index) => {
    boardSigns[board] = signs[index];
  });
  return {
    boardSigns,
    couponId,
    keepUserSigns,
    rSystem: undefined,
    system: undefined,
    xpertAnalysisAuthorId,
    overwriteCoupon
  };
};
const generateSportPixCoupon = createAsyncThunk('tipsen/generateSportPixCoupon', async _ref8 => {
  let {
    data
  } = _ref8;
  const {
    productId,
    drawNumber,
    system,
    type,
    numRows = 1,
    couponId,
    baseRow = [],
    keepUserSigns = false,
    xpertAnalysisAuthorId = null
  } = data;
  const boards = [];
  for (let i = 0; i < numRows; i++) {
    boards.push(i);
  }
  return _generateSportPixCoupon({
    productId,
    drawNumber,
    system,
    type,
    boards,
    couponId,
    baseRow,
    keepUserSigns,
    xpertAnalysisAuthorId,
    overwriteCoupon: true
  });
});
const generateSportPixCouponBoard = createAsyncThunk('tipsen/generateSportPixCouponBoard', async _ref9 => {
  let {
    productId,
    drawNumber,
    system,
    type,
    boardIndex = 0,
    couponId,
    baseRow = [],
    keepUserSigns = false,
    xpertAnalysisAuthorId = null
  } = _ref9;
  return _generateSportPixCoupon({
    productId,
    drawNumber,
    system,
    type,
    boards: [boardIndex],
    couponId,
    baseRow,
    keepUserSigns,
    xpertAnalysisAuthorId,
    overwriteCoupon: false
  });
});
const getWager = _ref10 => {
  let {
    state,
    draw,
    couponId,
    isPlayingCompetition,
    competition,
    isCompetitionSignUp
  } = _ref10;
  const wager = selectWager(state, draw, couponId, isPlayingCompetition, competition);
  const wagerProps = selectWagerProps(state, draw, couponId, isPlayingCompetition, isPlayingCompetition && isCompetitionSignUp, competition);
  wagerProps.extradata = _objectSpread(_objectSpread({}, wagerProps.extradata), isSelfService && {
    regCloseTime: draw.regCloseTime
  });
  return [wager, wagerProps];
};
const {
  isMarketplaceWallet
} = svs.components.tipsen.wallet.walletHelpers;
const {
  selectActiveWallet
} = svs.components.tipsen.walletSelectors;
const placeBetSingle = async _ref11 => {
  var _engine$defaultCoupon;
  let {
    state,
    draw,
    couponId,
    signs,
    engine,
    isPlayingCompetition,
    isCompetitionSignUp,
    competition,
    primaryWallet,
    relatedCouponId,
    selectedPixIndex
  } = _ref11;
  const [wager, wagerProps] = getWager({
    state,
    draw,
    couponId,
    isPlayingCompetition,
    competition,
    isCompetitionSignUp
  });
  const wagersToPay = [wager];
  const wagersPropsToPay = [wagerProps];
  const draws = [draw];
  const coupon = selectCoupon(state, couponId);
  let relatedWager;
  let relatedWagerProps;
  const wallet = selectActiveWallet(state);
  if (hasRelatedDrawPix && relatedCouponId && !isMarketplaceWallet(wallet) && selectedPixIndex) {
    const relatedDraw = makeSelectRelatedDraw(draw.productId, draw.drawNumber, 'PIX')(state) || {};
    [relatedWager, relatedWagerProps] = getWager({
      state,
      draw: relatedDraw,
      couponId: relatedCouponId,
      isPlayingCompetition: false,
      competition,
      isCompetitionSignUp,
      shouldPayRelatedCoupon: false
    });
    if (!selectIsRelatedCouponValid(state, relatedCouponId)) {
      relatedWager.errorPay = true;
    }
    wagersToPay.push(relatedWager);
    wagersPropsToPay.push(relatedWagerProps);
    draws.push(relatedDraw);
  }
  const price = wagerProps.message.price;
  const productName = wagersPropsToPay.map(wagerprop => wagerprop.message.product);
  let wagerResponses;
  try {
    const wagerRespons = await placeBetService(wagersToPay, wagersPropsToPay, draws); 
    wagerResponses = [].concat(wagerRespons);
  } catch (err) {
    const errorCode = parseInt(String(err.error.code).replace(/\s/g, ''), 10);
    const {
      errorMessage,
      title
    } = getTitleAndErrorMessageFromWagerResponse(errorCode);
    showErrorDialog(errorMessage, title);
    throw err.error;
  }
  let errorWagers = [];
  const isMoreThanOneWagerResponse = Array.isArray(wagerResponses);
  if (isMoreThanOneWagerResponse && wagersToPay.length !== wagerResponses.length || !isMoreThanOneWagerResponse && wagersToPay.length > 1) {
    const successfulWagers = [].concat(wagerResponses);
    const startIndex = wagersToPay.length - successfulWagers.length;
    errorWagers = wagersPropsToPay.slice(startIndex);
  }
  return {
    couponId,
    primaryWallet,
    price,
    productName,
    signs,
    isSingleRows: ((coupon === null || coupon === void 0 ? void 0 : coupon.boards.length) || 0) > 1,
    sportkryssNumber: generateSportkryssNumber(),
    wagerResponses,
    reduceModeCount: (_engine$defaultCoupon = engine.defaultCouponValues) === null || _engine$defaultCoupon === void 0 ? void 0 : _engine$defaultCoupon.reduceModeCount,
    compDesc: isPlayingCompetition && competition ? competition.compDesc : undefined,
    competitionSignedUp: isPlayingCompetition && isCompetitionSignUp,
    isPlayingCompetition,
    errorWagers
  };
};
const placeBetExternal = async _ref12 => {
  var _engine$defaultCoupon2;
  let {
    state,
    draw,
    couponId,
    signs,
    engine,
    isPlayingCompetition,
    isCompetitionSignUp,
    competition,
    primaryWallet
  } = _ref12;
  const coupon = selectCoupon(state, couponId);
  const wagers = selectWagers(state, draw, couponId, isPlayingCompetition, competition);
  const wagerLogger = getLogger('tipsen:wager');
  let price = coupon !== null && coupon !== void 0 && coupon.isExternal ? parseInt(coupon.totalPrice, 10) : selectPrice(state, couponId);
  const getDisplayNameByDraw = selectEngineDefinition(state).getDisplayNameByDraw;
  const productName = getDisplayNameByDraw(draw);
  const wagerResponses = [];
  const failedWagers = [];
  const selectNumberOfBoards = coupon.boards.length;
  const wallet = selectActiveWallet(state);
  const isMarketplace = isMarketplaceWallet(wallet) ? wallet.label : null;
  const selectSystem = coupon.boards[0].type;
  const externalSystemTotalWagerMaxSize = selectExternalSystemChunkSize(state, selectSystem, isMarketplace);
  if (isMarketplace && selectNumberOfBoards > externalSystemTotalWagerMaxSize) {
    const marketPlaceText = 'som läggs för lag (Spela tillsammans)';
    const message = selectSystem === externalSystemsBoardsType[externalSystemsType.SINGLE] ? "Externa systemspel ".concat(marketPlaceText, " kan inte vara st\xF6rre \xE4n ").concat(externalSystemTotalWagerMaxSize, " enkelrader.") : "M-system (matematiskt system) ".concat(marketPlaceText, " kan inte vara st\xF6rre \xE4n ").concat(externalSystemTotalWagerMaxSize, " rader vid externt systemspel.");
    const CustomException = {
      message,
      name: 'customError'
    };
    throw CustomException;
  }
  for (let wagerIndex = 0; wagerIndex < wagers.length; wagerIndex++) {
    const chunkData = wagers.length > 1 ? {
      index: wagerIndex,
      total: wagers.length
    } : undefined;
    const wagerProps = selectWagerProps(state, draw, couponId, isPlayingCompetition, isPlayingCompetition && isCompetitionSignUp, competition, chunkData);
    wagerProps.extradata = _objectSpread(_objectSpread(_objectSpread({}, wagerProps.extradata), isSelfService && {
      regCloseTime: draw.regCloseTime
    }), {}, {
      externalSystem: true
    });
    try {
      const response = await placeBetService(wagers[wagerIndex], wagerProps, draw, Boolean(chunkData));
      wagerResponses.push(response);
    } catch (err) {
      failedWagers.push(wagers[wagerIndex]);
      break;
    }
  }
  if (failedWagers.length > 0) {
    price = getTotalPaidSum(wagerResponses);
  }
  const successfulWagerClientSerials = wagerResponses.map(res => res.wagerClientSerial).join(',');
  if (coupon.guid && coupon.isExternal) {
    const options = {
      method: 'PUT',
      path: "/wager/1/ownwager/".concat(coupon.guid, "/paid"),
      data: {
        wagerSerials: successfulWagerClientSerials
      }
    };
    jupiter.call(options, () => {}, err => {
      wagerLogger.error("/wager/1/ownwager/".concat(coupon.guid, "/paid with serials: ").concat(successfulWagerClientSerials, " failed with error"), err);
    });
  }
  return {
    couponId,
    primaryWallet,
    price,
    productName,
    signs,
    isSingleRows: (coupon === null || coupon === void 0 ? void 0 : coupon.boards[0].type) === externalSystemsBoardsType[externalSystemsType.SINGLE],
    sportkryssNumber: generateSportkryssNumber(),
    wagerResponses,
    reduceModeCount: (_engine$defaultCoupon2 = engine.defaultCouponValues) === null || _engine$defaultCoupon2 === void 0 ? void 0 : _engine$defaultCoupon2.reduceModeCount,
    compDesc: isPlayingCompetition && competition ? competition.compDesc : undefined,
    competitionSignedUp: isPlayingCompetition && isCompetitionSignUp,
    isPlayingCompetition,
    failedWagers
  };
};
const placeBet = createAsyncThunk('tipsen/placeBet', async (_ref13, _ref14) => {
  let {
    productId,
    drawNumber,
    couponId,
    isPlayingCompetition = false,
    isCompetitionSignUp = false,
    competition = null,
    relatedCouponId
  } = _ref13;
  let {
    getState,
    dispatch
  } = _ref14;
  const wagerLogger = getLogger('tipsen:wager');
  let state = getState();
  const draw = selectById(state, "".concat(productId, "_").concat(drawNumber));
  let primaryWallet = null;
  if (userSession.hasRole(userSession.roles.PLAYER)) {
    primaryWallet = WALLET_ID_PLAYER;
  } else if (isSelfService) {
    primaryWallet = WALLET_ID_SELFSERVICE;
  }
  const coupon = selectCoupon(state, couponId);
  const engine = selectEngineDefinition(state);
  if (coupon.isExternal) {
    const signs = selectAllSigns(state, couponId);
    return await placeBetExternal({
      state,
      draw,
      couponId,
      signs,
      engine,
      isPlayingCompetition,
      isCompetitionSignUp,
      competition,
      primaryWallet
    });
  }
  const selectedPixIndex = selectCurrentAddonPixSizeIndex(state, relatedCouponId);
  const pixSizes = selectAddonPixSizes(state);
  const relatedDraw = makeSelectRelatedDraw(draw.productId, draw.drawNumber, 'PIX')(state) || {};
  if (relatedCouponId && selectedPixIndex && relatedDraw) {
    try {
      const options = {
        system: pixSizes[selectedPixIndex],
        productId: relatedDraw.productId,
        drawNumber: relatedDraw.drawNumber,
        couponId: relatedCouponId,
        type: XPERT_WAGER_MSYS,
        baseRow: [],
        keepUserSigns: false
      };
      await dispatch(generateSportPixCoupon({
        data: options,
        loadingMeta: {
          key: LoadingKeys.PIX,
          pause: 200
        }
      })).unwrap();
      state = getState();
    } catch (err) {
      wagerLogger.info("Error dispatching pix for related coupon: ".concat(err));
    }
  }
  const signs = ((coupon === null || coupon === void 0 ? void 0 : coupon.boards) || []).map(board => board.signs).filter((board, index) => !selectCouponBoardEmpty(state, couponId, index));
  return await placeBetSingle({
    state,
    draw,
    couponId,
    signs,
    engine,
    isPlayingCompetition,
    isCompetitionSignUp,
    competition,
    primaryWallet,
    relatedCouponId,
    selectedPixIndex
  });
});
setGlobal('svs.components.tipsen.engine.actions', {
  switchEngine,
  toggleAlternative,
  setExternalCoupon,
  selectBetAmount,
  setSportkryssFactorIndex,
  setSportkryssNumber,
  placeBet,
  clearCoupon,
  clearCouponBoard,
  selectWeek,
  selectSystem,
  toggleMSign,
  generateXpertCoupon,
  generateXpertCouponBoard,
  generateSportPixCoupon,
  generateSportPixCouponBoard,
  setCouponValues,
  resetWithCouponValues,
  setSignDistribution,
  setReduceModeCount,
  selectPixSize
});
 })(window);